export default "__VITE_ASSET__2wECiEok__"